/**
 * Punto de extensión del alta de una entidad con .projectSlots: algo que se
 * muestra después de guardar un alta con éxito (por ejemplo, ofrecer el paso
 * siguiente). El PROYECTO llena este archivo; el generador lo emite SIEMPRE con
 * este mismo contenido estable.
 *
 * Solo en las entidades marcadas con .projectSlots en el DSL, en su página de
 * alta y en la de sus proyecciones (con la clave de la entidad): no en un alta
 * dentro de un diálogo o de una ventana modal, ni cuando el alta se abrió desde
 * otro formulario para volver a él. Con un componente registrado para la
 * entidad, la página no se cierra al guardar: lo dibuja, y se cierra (como hoy)
 * cuando el componente llama a onDone. Mientras tanto, Guardar no vuelve a dar
 * de alta el registro.
 *
 * Props:
 *  - entity:   el nombre de la entidad.
 *  - recordId: el id del registro recién creado.
 *  - values:   los valores del formulario con que se guardó (los de
 *              <Entidad>ValuesType: un campo simple, por su nombre; una
 *              referencia, como show<Campo>, con { id, displayId }).
 *  - onDone:   cierra el alta, como hoy.
 *
 * NO EDITAR este stub en el generador: cualquier cambio acá conflictúa con
 * todos los proyectos que lo hayan llenado.
 */
import type { ComponentType } from 'react';
import { AuthorCreatedOffer } from "../../entities/authorComposer/components/common/AuthorCreatedOffer";

export interface CreatedExtrasProps {
  entity: string;
  recordId: string;
  values: Record<string, any>;
  onDone: () => void;
}

// Lleno por Jupiter: al guardar el alta de un autor, ofrecer la solicitud de validación.
export const createdExtras: Partial<Record<string, ComponentType<CreatedExtrasProps>>> = {
  AuthorComposer: AuthorCreatedOffer,
};
